import { GenericNavLink, GenericNavLinkProps } from '@this+that/ui';

import { SidebarRailTooltip } from '../../../SidebarRailTooltip/SidebarRailTooltip';

type SidebarNavLinkProps = Omit<GenericNavLinkProps, 'tooltipWrapper'>;

export function SidebarNavLink(props: Readonly<SidebarNavLinkProps>) {
  return <GenericNavLink {...props} tooltipWrapper={SidebarRailTooltip} />;
}
